import { create } from "zustand";
import {IUserIPRestrictionEntity} from './IPRestrictionInterface';

export interface IPRestrictionState {
  setIPRestriction: (ipRestrictions:IUserIPRestrictionEntity[]) => void;
  ipRestriction: IUserIPRestrictionEntity[];
  isUnifyRestricted:boolean;
  unifyRestrictedMessage:string;
  vpnInternalUrl: string;
  setVpnInternalUrl: (url: string) => void;
}

const _setIPRestriction  = (set: any) => (ipRestrictions:IUserIPRestrictionEntity[]) =>
  set(() => {
    const unifyApp = ipRestrictions?.find((entity: IUserIPRestrictionEntity) => 
        entity.entityId === 'UNIFY');
    const isUnifyRestricted = unifyApp?.isRestricted
    const unifyRestrictedMessage = unifyApp?.message
    return { 
      isUnifyRestricted :isUnifyRestricted ,
      unifyRestrictedMessage: unifyRestrictedMessage,
      ipRestriction:ipRestrictions,
    };
  });

export const useIPRestrictionStore = create<IPRestrictionState>((set) => ({
 ipRestriction: [],
 isUnifyRestricted:false,
 unifyRestrictedMessage:'',
 vpnInternalUrl:'',
 setIPRestriction: _setIPRestriction(set),
 setVpnInternalUrl: (url: string) => set(() => ({ vpnInternalUrl: url })),
}));